const USD_CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatUsdFromCents = (cents: number | null, fallback = "TBD"): string => {
  if (cents === null) {
    return fallback;
  }

  return USD_CURRENCY_FORMATTER.format(cents / 100);
};
